(function () {
    "use strict";

    document.addEventListener('hidden.bs.modal', function (e) {
        const modal = e.target.closest('#product-videos-modal');
        if (modal) {
            modal.querySelectorAll('video').forEach(video => {
                video.pause();
            });
        }
    });

    document.addEventListener('shown.bs.modal', function (e) {
        const modal = e.target.closest('#product-gallery-modal');
        if (modal && window.jQuery && typeof window.jQuery.fn.magnify === 'function') {
            window.jQuery(modal).find('.img-magnifier-container img[data-magnify-src], .woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image img').each(function () {
                window.jQuery(this).magnify({
                    speed: 200,
                    src: window.jQuery(this).attr("src"),
                });
            });
        }
    });

    document.addEventListener('init_carousel', function (e) {
        if (e.target.matches('.woocommerce-product-gallery')) {
            const wrapper = e.target.querySelector('.woocommerce-product-gallery__wrapper');
            if (wrapper) {
                Array.from(wrapper.children).forEach(child => {
                    child.classList.add('swiper-slide');
                });
            }
            e.target.style.opacity = '1';
        }
    }, true);

    const gallery = document.querySelector('.woocommerce-product-gallery');
    const galleryWrapper = document.querySelector('.woocommerce-product-gallery__wrapper');
    const navigation = document.querySelector('.woocommerce-product-gallery__navigation');
    const modalGalleryWrapper = document.querySelector('.product-gallery-wrapper .modal-gallery .swiper-wrapper');
    const modalThumbWrapper = document.querySelector('.product-gallery-wrapper .modal-gallery-thumbnail .swiper-wrapper');

    if (gallery && gallery.classList.contains('swiper-initialized')) {
        gallery.style.opacity = '1';
    }

    const initialGalleryWrapperHTML = galleryWrapper ? galleryWrapper.innerHTML : '';
    let galleryClasses = gallery ? gallery.getAttribute('class') : '';
    if (galleryClasses) {
        galleryClasses = galleryClasses.replace('flexslider', '').trim();
    }
    const galleryColumns = gallery ? (gallery.getAttribute('data-columns') || 4) : 4;

    const initialNavigationHTML = navigation ? navigation.innerHTML : '';
    const initialModalGalleryHTML = modalGalleryWrapper ? modalGalleryWrapper.innerHTML : '';
    const initialModalThumbHTML = modalThumbWrapper ? modalThumbWrapper.innerHTML : '';

    let isVariationActive = false;

    function updateGallery(galleryWrapperHTML, navigationHTML, modalGalleryHTML, modalThumbHTML) {
        const currentGallery = document.querySelector('.woocommerce-product-gallery');
        if (currentGallery) {
            const oldSwiper = currentGallery.swiper || (window.jQuery ? window.jQuery(currentGallery).data('swiper') : null);
            if (oldSwiper && typeof oldSwiper.destroy === 'function') {
                oldSwiper.destroy(true, true);
            }

            const newGalleryNode = currentGallery.cloneNode(false);
            newGalleryNode.style.opacity = '0';

            const newWrapperNode = document.createElement('div');
            newWrapperNode.className = 'woocommerce-product-gallery__wrapper swiper-wrapper';
            newWrapperNode.innerHTML = galleryWrapperHTML;

            newGalleryNode.appendChild(newWrapperNode);

            currentGallery.parentNode.replaceChild(newGalleryNode, currentGallery);

            newGalleryNode.dispatchEvent(new CustomEvent('init_carousel', { bubbles: true }));
        }

        if (navigation) {
            navigation.innerHTML = navigationHTML;
        }

        const modalGallery = document.querySelector('.product-gallery-wrapper .modal-gallery');
        const modalThumb = document.querySelector('.product-gallery-wrapper .modal-gallery-thumbnail');

        const gallerySwiper = modalGallery ? modalGallery.swiperInstance || modalGallery.swiper || (window.jQuery ? window.jQuery(modalGallery).data('swiper') : null) : null;
        const thumbSwiper = modalThumb ? modalThumb.swiperInstance || modalThumb.swiper || (window.jQuery ? window.jQuery(modalThumb).data('swiper') : null) : null;

        if (modalGalleryWrapper) {
            modalGalleryWrapper.innerHTML = modalGalleryHTML;
        }
        if (modalThumbWrapper) {
            modalThumbWrapper.innerHTML = modalThumbHTML;
        }

        if (gallerySwiper) {
            gallerySwiper.update();
            gallerySwiper.slideTo(0);
        }
        if (thumbSwiper) {
            thumbSwiper.update();
            thumbSwiper.slideTo(0);
        }

    }

    document.addEventListener('DOMContentLoaded', function () {

        if (window.jQuery) {
            window.jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
                if (this.closest('.modal')){ // is modal view
                    return;
                }
                if (variation && (variation.variation_gallery || variation.has_variation_image)) {
                    const galleryHTML = variation.variation_gallery_html;
                    const navigationHTML = variation.variation_navigation_html;
                    const modalGalleryHTML = variation.variation_modal_gallery_html;
                    const modalThumbHTML = variation.variation_modal_thumb_html;

                    if (galleryHTML && navigationHTML && modalGalleryHTML && modalThumbHTML) {
                        isVariationActive = true;
                        updateGallery(galleryHTML, navigationHTML, modalGalleryHTML, modalThumbHTML);
                    }
                }
            });

            window.jQuery(document).on('reset_data', 'form.variations_form', function () {
                if (this.closest('.modal')){ // is modal view
                    return;
                }
                if (isVariationActive) {
                    updateGallery(initialGalleryWrapperHTML, initialNavigationHTML, initialModalGalleryHTML, initialModalThumbHTML);
                    isVariationActive = false;
                }
            });
        }
    });

    document.addEventListener('click', function (e) {
        const galleryImage = e.target.closest('.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image');
        if (galleryImage) {
            e.preventDefault();
            return;
        }

        const navItem = e.target.closest('.woocommerce-product-gallery__navigation .navigation-item--image, .woocommerce-product-gallery__navigation .navigation-item--more');
        if (navItem) {
            e.preventDefault();
            const parent = navItem.parentNode;
            const siblings = Array.from(parent.children);
            let imageIndex = siblings.indexOf(navItem);
            if (navItem.classList.contains('navigation-item--more')) {
                imageIndex = 0;
            }

            const modalGallery = document.querySelector('.product-gallery-wrapper .modal-gallery');
            const gallerySlider = modalGallery ? modalGallery.swiperInstance || modalGallery.swiper || (window.jQuery ? window.jQuery(modalGallery).data('swiper') : null) : null;
            if (gallerySlider) {
                gallerySlider.slideTo(imageIndex);
            }

            const galleryModalEl = document.getElementById('product-gallery-modal');
            if (galleryModalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                const modal = bootstrap.Modal.getOrCreateInstance(galleryModalEl);
                modal.show();
            }
        }
    });

})();
